import { sessionStorageKeys } from 'lib/consts/browserStorage'
import { getSSItem } from 'lib/helpers/getSSItem/getSSItem'

/**
 * Stores the email paired with the MFA challenge in `sessionStorage`, so it is scoped to the tab and
 * dropped when the tab closes. The email is not sensitive and is useless on its own — the challenge it
 * pairs with is minted from the grant, whose validity the backend owns — so it carries no TTL. Cleared
 * via `clearStoredMfaAuthData` by the flows that own the sign-in lifecycle.
 */
export const storedMfaEmail = {
  set(mfaEmail: string): void {
    window.sessionStorage.setItem(sessionStorageKeys.mfaEmail, mfaEmail)
  },

  get(): string | null {
    return getSSItem(sessionStorageKeys.mfaEmail)
  },

  clear(): void {
    window.sessionStorage.removeItem(sessionStorageKeys.mfaEmail)
  },
}
